import React, { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Grid,
  ButtonGroup
} from '@mui/material';
import { PhotoCamera, Delete, PhotoLibrary } from '@mui/icons-material';

export default function ImageUploader({ initialImages = [], onImagesSelected, maxImages = 5 }) {
  const [images, setImages] = useState(initialImages);
  
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    
    if (images.length + files.length > maxImages) {
      alert(`Maximal ${maxImages} Bilder erlaubt`);
      return;
    }

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImage = {
          name: file.name,
          data: reader.result,
          mime_type: file.type,
          description: ''
        };
        const updatedImages = [...images, newImage];
        setImages(updatedImages);
        onImagesSelected(updatedImages);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleDescriptionChange = (index, description) => {
    const updatedImages = [...images];
    updatedImages[index].description = description;
    setImages(updatedImages);
    onImagesSelected(updatedImages);
  };

  const handleRemoveImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
    onImagesSelected(updatedImages);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">
          Bilder ({images.length}/{maxImages})
        </Typography>
        <ButtonGroup variant="contained" disabled={images.length >= maxImages}>
          {/* Kamera Button - öffnet direkt die Kamera */}
          <Button
            component="label"
            startIcon={<PhotoCamera />}
            disabled={images.length >= maxImages}
          >
            Kamera
            <input
              type="file"
              hidden
              accept="image/*"
              capture="environment"
              onChange={handleImageUpload}
            />
          </Button>
          
          {/* Galerie Button - öffnet Galerie/Dateiauswahl */}
          <Button
            component="label"
            startIcon={<PhotoLibrary />}
            disabled={images.length >= maxImages}
          >
            Galerie
            <input
              type="file"
              hidden
              accept="image/*"
              multiple
              onChange={handleImageUpload}
            />
          </Button>
        </ButtonGroup>
      </Box>

      {images.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
          Keine Bilder hochgeladen
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {images.map((image, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card>
                <CardMedia
                  component="img"
                  height="140"
                  image={image.data}
                  alt={image.name}
                />
                <CardContent>
                  <Typography variant="caption" display="block" gutterBottom>
                    {image.name}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    label="Hinweistext"
                    value={image.description}
                    onChange={(e) => handleDescriptionChange(index, e.target.value)}
                    placeholder="Optional - Hinweistext zum Foto"
                  />
                </CardContent>
                <CardActions>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleRemoveImage(index)}
                  >
                    <Delete />
                  </IconButton>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}